module.exports = __webpack_public_path__ + "static/media/GoogleIconResp.82aa40d5.svg";